import { createImmutableObjectClass } from 'immutable-less';
export default class PropertyField extends createImmutableObjectClass({
  propertyName: null,
  valueType: 'PROPERTY'
}) {
  getIsValueEmpty() {
    return !this.propertyName;
  }
  /**
   * @deprecated Prefer dot notation: .propertyName
   */
  getPropertyName() {
    return this.propertyName;
  }
  getValue() {
    return this.propertyName;
  }
  /**
   * @deprecated Prefer dot notation: .valueType
   */
  getValueType() {
    return this.valueType;
  }
}